/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import { useIntl } from 'react-intl';
import { KTIcon } from '../../../../helpers';
import { SidebarMenuItemWithSub } from './SidebarMenuItemWithSub';
import { SidebarMenuItem } from './SidebarMenuItem';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../global/store';

const SidebarMenuMain = () => {
	const intl = useIntl();
	const dataCapel = useSelector((v: RootState) => v.customerReducer.identify);
	const capelId = localStorage.getItem('capelId');
	const custNum = localStorage.getItem('customerNum');

	const REACT_APP_DEVELOPMENT = process.env.REACT_APP_DEVELOPMENT;

	return (
		<>
			{
				((capelId !== '' && custNum !== '' && custNum != null) || custNum != null) && dataCapel != null ? (
					<>
						<div className="menu-item">
							<div className="menu-content pb-2">
								<span className="menu-section text-dark text-uppercase fs-6 ls-1 fw-semibold">
									{dataCapel?.cust_name_decrypt}
								</span>
							</div>
							<div className="menu-content pb-5">
								<span className="menu-section text-dark text-uppercase fs-7 ls-1">
									{dataCapel?.cust_number}
								</span>
							</div>
						</div>
						<SidebarMenuItem
							to="/dashboard"
							icon="element-11"
							title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
							fontIcon="bi-app-indicator"
						/>
						<SidebarMenuItem
							to="/customer-profile/identify"
							title="Customer profile"
							icon="bi bi-person-circle"
						/>
						<SidebarMenuItem
							to="/usage"
							title="Usage"
							icon="bi bi-fire"
						/>
						<SidebarMenuItem
							to="/purchase-history/1"
							title="Payment history"
							icon="bi bi-clock-history"
						/>
						{
							REACT_APP_DEVELOPMENT && REACT_APP_DEVELOPMENT == '1' && capelId != 'null' && capelId != null &&
							<SidebarMenuItem
								to="/gas-subscription/1"
								title="Gas subscription"
								icon="bi bi-repeat"
							/>
						}
						{REACT_APP_DEVELOPMENT && REACT_APP_DEVELOPMENT == '1' && (<SidebarMenuItem
							to="/amendment/1"
							title="Amendment"
							icon="bi bi-file-earmark-text-fill"
						/>)}
						{REACT_APP_DEVELOPMENT && REACT_APP_DEVELOPMENT == '1' && (<SidebarMenuItem
							to="/promotions"
							title="Promo"
							icon="bi bi-scissors"
						/>)}
						{REACT_APP_DEVELOPMENT && REACT_APP_DEVELOPMENT == '1' && (<SidebarMenuItem
							to="/customer-support/1"
							title="Service request"
							icon="bi bi-gear"
						/>)}
					</>
				) : (
					<>
						<SidebarMenuItem
							to="/gas-subscription/1"
							title="Gas subscription"
							icon="bi bi-repeat"
						/>
					</>
				)}

			{/* dlt <SidebarMenuItemWithSub to='/error' title='Invoice' fontIcon='bi-sticky' icon='cross-circle'>
        <SidebarMenuItem to='/error/404' title='Error 404' hasBullet={true} />
        <SidebarMenuItem to='/error/500' title='Error 500' hasBullet={true} />
      </SidebarMenuItemWithSub> */}
			{/* dlt <SidebarMenuItemWithSub
        to='/crafted/widgets'
        title='Tagihan'
        icon='element-7'
        fontIcon='bi-layers'
      >
        <SidebarMenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
        <SidebarMenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
      </SidebarMenuItemWithSub> */}
			{/* <div className="menu-item">
        <div className="menu-content pt-8 pb-2">
          <span className="menu-section text-muted text-uppercase fs-8 ls-1">
            Konfigurasi
          </span>
        </div>
      </div> */}
			{/* <SidebarMenuItem
        to="/apps/user-management/users"
        title="User management"
        icon="bi bi-person-gear"
      />
      <SidebarMenuItem
        to="/apps/user-management/users"
        title="Menu management"
        icon="bi bi-menu-button-wide"
      /> */}
		</>
	);
};

export { SidebarMenuMain };
